import React from "react";
import * as Icons from "lucide-react";
import { PROCESS } from "../data/mock";

const Process = () => {
  return (
    <section id="process" className="relative aaa-process-gradient py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "radial-gradient(circle at 30% 20%, #fff 0, transparent 40%)" }} />
      <div className="aaa-container relative">
        <div className="text-center max-w-2xl mx-auto">
          <p className="aaa-eyebrow mb-3" style={{ color: "rgba(255,255,255,0.75)" }}>
            {PROCESS.eyebrow}
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white">
            {PROCESS.title}
          </h2>
        </div>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {PROCESS.steps.map((step, i) => {
            const Icon = Icons[step.icon] || Icons.Circle;
            return (
              <div key={step.title} className="text-center group">
                <div className="mx-auto w-20 h-20 rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center mb-5 transition-transform duration-300 group-hover:-translate-y-2">
                  <Icon size={34} className="text-white" strokeWidth={1.6} />
                </div>
                <div className="text-white/60 font-display text-sm mb-1">
                  0{i + 1}
                </div>
                <h3 className="font-display text-xl font-bold text-white mb-2">
                  {step.title}
                </h3>
                <p className="text-white/80 text-[0.9rem] leading-relaxed max-w-[220px] mx-auto">
                  {step.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
